import { createReducer } from '@reduxjs/toolkit';
import { OrderEnum } from 'enums/orderEnum';
import { SearchByEnum } from 'enums/searchByEnum';
import {
  clearSelectedEntries,
  getContentSuccess,
  getContentTypesSuccess,
  getTaxonomySuccess,
  getWorkflowStepsSuccess,
  setPagination,
  setSelectedEntries,
  toggleAllEntries,
  toggleEntry,
} from './content.actions';
import { IContentState } from './content.interface';

const initState: IContentState = {
  pagination: {
    page: 0,
    size: 10,
    order: OrderEnum.DESC,
    orderBy: 'system.last_modified',
    search: '',
    searchBy: SearchByEnum.NAME,
    contentType: [],
    workflowStep: [],
    publishedState: [],
    taxonomies: [],
  },
  isFiltered: false,
  workflowSteps: [],
  contentTypes: [],
  totalPages: 0,
  taxonomies: [],
};

export const contentReducer = createReducer(initState, (builder) =>
  builder
    .addCase(getContentSuccess, (state, { payload: { data, totalPages } }) => {
      state.data = data;
      state.totalPages = totalPages;
      state.selected = [];
    })
    .addCase(setPagination, (state, { payload }) => {
      state.pagination = payload;
      state.isFiltered = Boolean(
        payload.contentType.length ||
          payload.workflowStep.length ||
          payload.publishedState.length ||
          payload.taxonomies.length,
      );
    })
    .addCase(getWorkflowStepsSuccess, (state, { payload }) => {
      state.workflowSteps = payload;
    })
    .addCase(getContentTypesSuccess, (state, { payload }) => {
      state.contentTypes = payload;
    })
    .addCase(toggleEntry, (state, { payload }) => {
      state.selected = state?.selected?.filter((element) => element.id === payload.id).length
        ? state?.selected?.filter((element) => element.id !== payload.id)
        : [...(state?.selected || []), payload];
    })
    .addCase(toggleAllEntries, (state) => {
      state.selected = state?.data?.length !== state?.selected?.length ? state?.data : [];
    })
    .addCase(clearSelectedEntries, (state) => {
      state.selected = undefined;
    })
    .addCase(setSelectedEntries, (state, { payload }) => {
      state.selected = payload;
    })
    .addCase(getTaxonomySuccess, (state, { payload }) => {
      state.taxonomies = payload;
    }),
);
